import {
  type AdminCertificationRequestsListParams,
  getAdminCertificationRequestsListQueryOptions,
  getCertificationsListQueryOptions,
} from "@sidegigllc/api/client";
import { marketsQueryOptions } from "api/queries/markets";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: AdminCertificationRequestsListParams };

export const requestsQuery = ({ search }: QueriesInput) => getAdminCertificationRequestsListQueryOptions(search);
export const certTypesQuery = () => getCertificationsListQueryOptions({ page_size: 200, is_active: true });
export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  requestsQuery(input),
  certTypesQuery(),
  marketsQueryOptions(),
];
